export default __webpack_public_path__ + "3ab9aff70e6b8dc1d7c66438ae95f322.svg";